module.exports = __webpack_public_path__ + "img/1447776130.3431131c.jpg";